<template>
  <div>
    <div class="login" @click="onFBLogin()"></div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'Facebook',
  data () {
    return {
      userInfo: {},
      isRepeat: false
    }
  },
  methods: {
    onFBLogin() {
      const _this = this
      // 检测FB登录状态
      window.FB.getLoginStatus(function(statusRes) { // Called after the JS SDK has been initialized.
        console.log('statusRes======', statusRes)
        if (statusRes.status === 'connected') { // 已登录
          _this.getInfo(statusRes.authResponse)
          // Has logged into your webpage and Facebook.
        } else { // 未登录进行登录
          window.FB.login(function(loginRes) {
            console.log('loginRes====', loginRes)
            if (loginRes.status === 'connected') {
              // Logged into your webpage and Facebook.
              _this.getInfo(loginRes.authResponse)
            } else {
              _this.$msg.success(_this.$t('login_fail_2'))
              window.FB.logout()
              // The person is not logged into your webpage or we are unable to tell.
            }
          }, { scope: 'public_profile, email' })
        }
      })
    },
    getInfo (authRes) {
      const _this = this
      window.FB.api('/me', function(profileRes) {
        console.log(profileRes)
        if (!profileRes.id) {
          window.FB.logout()
          if (!_this.isRepeat) {
            _this.isRepeat = true
            setTimeout(() => {
              _this.onFBLogin()
            }, 300);
            return
          }
          _this.$msg.success(_this.$t('login_fail_2'))
          return
        }
        console.log('authRes=======', JSON.stringify(authRes))
        console.log('profileRes=======', JSON.stringify(profileRes))
        _this.isRepeat = false
        _this.userInfo = {
          id: profileRes.id || '',
          name: profileRes.name,
          token: authRes.accessToken,
          type: _this.$ENUM.SOCIAL_MAP.FACEBOOK,
          expire: authRes.expiresIn
        }
        _this.login()
      })
    },
    login () {
      this.$emit('changePopup', {
        name: 'Result',
        params: {
          type: 'success',
          loginData: this.userInfo
        }
      })
    }
  }
}
/* eslint-enable */
</script>

<style lang='less' scoped >
.login {
  width: 31px;
  height: 31px;
  background: url(~@img/icon_facebook.png) center center no-repeat;
  background-size: 100% 100%;
}

</style>
